import React from 'react';
import { PropTypes } from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import AUbutton from '@gov.au/buttons';

/* DEFAULT
 * The heading component
 * 
 * @param  {boolean}   active        - state of modal
 * @param  {string}    children      - modal body text
 * @param  {string}    heading       - heading
 * @param  {function}  action        - function to do on confirmation 
 * @param  {string}    actionLabel   - label for the action button
 * @param  {function}  toggle        - function for toggling off
 */
const CasaModal = ({ active, toggle, heading, actionLabel, cancelLabel, image, imageText, action, children }) => {
    return (
        <Modal
            isOpen={active}
            toggle={toggle}
            modalTransition={{ timeout: 700 }}
            fade={false}
            >
            <ModalHeader>
                {heading}
                <div className='casa-modal-close'>
                    <a onClick={toggle}><span>Close</span></a>
                </div>
            </ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
            <ModalFooter>
                {image !== '' ?
                    <div>
                        <img src={image} style={{ width: '100%' }} onClick={action} alt={imageText} />
                        <br/><br/>
                        <AUbutton id='Cancel' onClick={toggle} as='secondary'>{cancelLabel}</AUbutton>
                    </div>
                    : null}
                {image === '' ?
                    <div>
                        <AUbutton id='ModalAction' as='secondary' onClick={action}>
                            {actionLabel}
                        </AUbutton>
                        <AUbutton id='Cancel' onClick={toggle} as='secondary'>{cancelLabel}</AUbutton>
                    </div>
                    : null
                }
            </ModalFooter>
        </Modal>
    )
};

CasaModal.propTypes = {
    heading: PropTypes.string.isRequired,
    active: PropTypes.bool,
    actionLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    action: PropTypes.func.isRequired,
    image: PropTypes.string,
    imageText: PropTypes.string,
    children: PropTypes.object,
    toggle: PropTypes.func
};

CasaModal.defaultProps = {
    image: '',
    actionLabel: "Yes",
    cancelLabel: "No",
    active: false
}

export default CasaModal;